import { CartUpdateEvent } from '@theme/events';

const config = document.querySelector('#noeva-free-gift');
if (config && !window.Shopify?.designMode) {
  const variant = Number(config.dataset.variant);
  const minimum = Number(config.dataset.minimum);
  const root = window.Shopify?.routes?.root || '/';
  const marker = '_noeva_gift';
  const source = 'noeva-free-gift';
  let pending;
  let timer;
  let replaying = false;
  let failedBasket = '';

  const isGift = (item) => Number(item.variant_id) === variant && item.properties?.[marker] === 'cosrx-39';
  const signature = (cart) => JSON.stringify(cart.items.filter((item) => !isGift(item)).map((item) => [item.key, item.quantity, item.original_line_price]));
  const read = async () => {
    const response = await fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin' });
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  };
  const sectionIds = () => [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((item) => item.dataset.sectionId))].slice(0, 5);
  const write = async (action, body) => {
    const response = await fetch(root + 'cart/' + action + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: sectionIds(), sections_url: location.pathname }),
    });
    if (!response.ok) throw new Error('Gift unavailable');
    return response.json();
  };
  const notify = (cart, sections) => document.dispatchEvent(new CartUpdateEvent(cart, source, { source, itemCount: cart.item_count, sections }));

  async function reconcile() {
    let cart = await read();
    let sections;
    let changed = false;
    for (let pass = 0; pass < 4; pass += 1) {
      const gifts = cart.items.filter(isGift);
      const paid = cart.items.filter((item) => !isGift(item)).reduce((sum, item) => sum + item.final_line_price, 0);
      const eligible = cart.currency === 'EUR' && paid >= minimum;
      const basket = signature(cart);
      if (!eligible && gifts.length) {
        const updates = Object.fromEntries(gifts.map((item) => [item.key, 0]));
        const result = await write('update', { updates });
        sections = result.sections;
        cart = result;
        changed = true;
        continue;
      }
      if (!eligible) break;
      if (gifts.length > 1 || gifts[0]?.quantity > 1) {
        const updates = Object.fromEntries(gifts.map((item, index) => [item.key, index === 0 ? 1 : 0]));
        const result = await write('update', { updates });
        sections = result.sections;
        cart = result;
        changed = true;
        continue;
      }
      if (gifts.length) {
        if (gifts[0].final_line_price !== 0) {
          failedBasket = basket;
          const result = await write('update', { updates: { [gifts[0].key]: 0 } });
          sections = result.sections;
          cart = result;
          changed = true;
        }
        break;
      }
      if (failedBasket === basket) break;
      try {
        const result = await write('add', { items: [{ id: variant, quantity: 1, properties: { [marker]: 'cosrx-39' } }] });
        sections = result.sections;
        cart = await read();
        changed = true;
      } catch {
        failedBasket = basket;
        break;
      }
    }
    if (changed) notify(cart, sections);
    return cart;
  }

  function sync() {
    if (!pending) pending = reconcile().finally(() => { pending = undefined; });
    return pending;
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (document.visibilityState === 'visible') sync().catch(() => {});
    }, 180);
  }
  document.addEventListener('cart:update', (event) => {
    if (event.detail?.sourceId !== source) schedule();
  });
  document.addEventListener('discount:update', schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule();
  });
  window.addEventListener('pageshow', schedule);
  if ('PerformanceObserver' in window) {
    new PerformanceObserver((list) => {
      if (list.getEntries().some((entry) => {
        const url = new URL(entry.name, location.href);
        return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
      })) schedule();
    }).observe({ type: 'resource', buffered: false });
  }


  function decorateGift() {
    const giftPrice = document.documentElement.lang.toLowerCase().startsWith('lt') ? '0 € (DOVANA)' : '0 € (Gift)';
    const giftTitle = 'COSRX kaukė dovanų nuo 39 €';
    document.querySelectorAll('.salemaximize__all_discount').forEach((block) => {
      const labels = [...block.querySelectorAll('.smeDiscountTagLable .salemaximize_line_discountText')];
      block.classList.toggle('noeva-gift-discount-label', labels.length > 0 && labels.every((label) => label.textContent.trim() === giftTitle));
    });
    document.querySelectorAll('.smeLineItemDiscountTag, cart-items-component .cart-items__variants-wrapper li').forEach((element) => {
      if (element.textContent.trim() === giftTitle) {
        element.classList.add('noeva-gift-discount-label');
        const list = element.closest('ul');
        if (list && [...list.children].every((child) => child.classList.contains('noeva-gift-discount-label'))) list.classList.add('noeva-gift-discount-label');
      }
    });
    document.querySelectorAll('.salemaximize__cart-item[data-variant-id="' + variant + '"]').forEach((row) => {
      const price = row.querySelector('.smeSellingPrice');
      const zero = price && Number(price.textContent.replace(/[^0-9,.-]/g, '').replace(',', '.')) === 0;
      row.classList.toggle('noeva-free-gift-line', Boolean(zero));
      if (zero && price.textContent !== giftPrice) price.textContent = giftPrice;
    });
    document.querySelectorAll('cart-items-component tr[data-key^="' + variant + ':"]').forEach((row) => {
      const price = row.querySelector('.cart-items__unit-price-wrapper > div > span:not(.visually-hidden)');
      const zero = price && Number(price.textContent.replace(/[^0-9,.-]/g, '').replace(',', '.')) === 0;
      row.classList.toggle('noeva-free-gift-line', Boolean(zero));
      if (zero) {
        if (price.textContent !== giftPrice) price.textContent = giftPrice;
        const total = row.querySelector('.cart-items__price text-component');
        if (total && total.textContent !== giftPrice) total.textContent = giftPrice;
      }
    });
  }

  new MutationObserver((records) => {
    decorateGift();
    const cartChanged = records.some((record) => {
      const element = record.target instanceof Element ? record.target : record.target.parentElement;
      if (element?.closest('.cartItemMainBlock')) return true;
      return [...record.addedNodes, ...record.removedNodes].some((node) => node instanceof Element && (node.matches('.cartItemMainBlock') || node.querySelector('.cartItemMainBlock')));
    });
    if (cartChanged) schedule();
  }).observe(document.body, { childList: true, characterData: true, subtree: true });
  decorateGift();
  schedule();
}
